import { Box, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

import {
  CohortSectionHeader,
  type CohortSectionHeaderProps,
} from './CohortSectionHeader/CohortSectionHeader';
import {
  CohortBuilderEmptyStateCard,
  CohortBuilderEmptyStateCardProps,
} from '../CohortBuilderEmptyStateCard/CohortBuilderEmptyStateCard';

export interface CohortSectionProps {
  headerProps: CohortSectionHeaderProps;
  emptyStateProps?: CohortBuilderEmptyStateCardProps;
}

export const CohortSection = ({
  children,
  headerProps,
  emptyStateProps,
}: PropsWithChildren<CohortSectionProps>) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        padding: '24px',
        border: '1px solid #D3D4D7',
        borderRadius: '8px',
        backgroundColor: '#FFFFFF',
        boxShadow: '2px 4px 4px 0px rgba(0, 0, 0, 0.08)',
        width: '100%',
        minWidth: theme.breakpoints.values.sm,
        maxWidth: theme.breakpoints.values.xl,
      }}
    >
      <CohortSectionHeader {...headerProps} />
      {children ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(6),
          }}
        >
          {children}
        </Box>
      ) : (
        emptyStateProps && <CohortBuilderEmptyStateCard {...emptyStateProps} />
      )}
    </Box>
  );
};
